import React, { Component, Fragment } from 'react';
import { Container, Row, Col, Input, Label, Button, Form, FormGroup } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck, faTimes, faCircle, faTrashAlt, faGripLines } from '@fortawesome/free-solid-svg-icons'
import { faCircle as faCircleOutline } from '@fortawesome/free-regular-svg-icons'
import ReactDragListView from 'react-drag-listview'
import PermissionWrapper from '../../auth/PermissionWrapper';
import ConfirmButton from '../Modal/ConfirmButton';

class Widgets extends Component {

  standardRow = (widget) => {
    this.props.info('Widgets.js/standardRow (widget)', widget);
    const clientsCount = widget.clients.filter(item => item > 0).length;
    return (
      <Row className="adminRow pointer widgetRow" onClick={() => this.props.onEdit(widget.widgetId)}>
        <Col md={4} className="text-left">
          <FontAwesomeIcon icon={(widget['active']) ? faCircle : faCircleOutline} className={"mr-3 " + ((widget['active']) ? 'iconActive' : 'iconInactive')} />
          {widget['name']}
        </Col>
        <Col md={4} className="text-left">{widget['description']}</Col>
        <Col md={3} className="text-left">{clientsCount} Client{clientsCount === 1 ? '' : 's'}</Col>
        <PermissionWrapper hidden={true} refreshUser={this.props.refreshUser} {...this.props} {...this.state} allowedPermission="Reorder Widgets">
          <Col md={1} className="text-right" onMouseDown={() => this.props.setDragTarget(null)}>
            <span className="dragIcon p-2"><FontAwesomeIcon icon={faGripLines} /></span>
          </Col>
        </PermissionWrapper>
      </Row>
    )
  }

  editRow = (widget) => {
    this.props.log('Widgets.js/editRow (widget)', widget);
    return (<>
      <Row key={"edit" + widget.widgetId} className="adminRow activeTab">
        <Col md={8} className="text-left">
          <Form inline>
            <FormGroup className="pr-2 pb-2">
              <Input
                placeholder="Name"
                type="text"
                id={"edit-name" + widget.widgetId}
                name="name"
                value={this.props.isFieldNull(this.props.editWidget.name)}
                onChange={e => this.props.onChange(e, 'edit')} />
            </FormGroup>
            <FormGroup className="pr-2 pb-2">
              <Input
                placeholder="Description"
                type="text"
                id={"edit-description" + widget.widgetId}
                name="description"
                value={this.props.isFieldNull(this.props.editWidget.description)}
                onChange={e => this.props.onChange(e, 'edit')} />
            </FormGroup>
            <FormGroup className="pr-2 pb-2">
              <Input
                placeholder="Types"
                type="text"
                id={"edit-types" + widget.widgetId}
                name="types"
                value={this.props.isFieldNull(this.props.editWidget.types)}
                onChange={e => this.props.onChange(e, 'edit')} />
            </FormGroup>
            <FormGroup className="pr-2 pb-2">
              <Input
                placeholder="Module"
                type="text"
                id={"edit-module" + widget.widgetId}
                name="module"
                value={this.props.isFieldNull(this.props.editWidget.module)}
                onChange={e => this.props.onChange(e, 'edit')} />
            </FormGroup>
            <FormGroup className="pr-2 pb-2">
              <Input
                type="checkbox"
                id={"edit-active" + widget.widgetId}
                name="active"
                checked={this.props.isFieldNull(this.props.editWidget.active, true)}
                onChange={e => this.props.onChange(e, 'edit')} />
              <Label for={"edit-active" + widget.widgetId}>
                Active
              </Label>
            </FormGroup>
          </Form>
        </Col>
        <Col md={4} className="text-right">
          <PermissionWrapper hidden={true} refreshUser={this.props.refreshUser} {...this.props} {...this.state} allowedPermission="Edit Widgets">
            <Button className="mx-1" color="success" onClick={this.props.handleEdit} title="Edit Widget">
              <FontAwesomeIcon icon={faCheck} />
            </Button>
          </PermissionWrapper>
          <PermissionWrapper hidden={true} refreshUser={this.props.refreshUser} {...this.props} {...this.state} allowedPermission="Delete Widgets">
            <ConfirmButton className="mx-3" color="danger" onClick={() => this.props.onDelete(widget.widgetId)} title="Delete Widget">
              <FontAwesomeIcon icon={faTrashAlt} />
            </ConfirmButton>
          </PermissionWrapper>
          <Button className="mx-1" color="secondary" onClick={this.props.handleCancel} title="Cancel">
            <FontAwesomeIcon icon={faTimes} />
          </Button>
        </Col>
        <Col md={4} className="text-left py-3 px-0">
          <FormGroup className="px-2">
            <Input
              placeholder="Configuration"
              type="textarea"
              id={"edit-configuration" + widget.widgetId}
              name="configuration"
              value={this.props.isFieldNull(this.props.editWidget.configuration)}
              onChange={e => this.props.onChange(e, 'edit')} />
          </FormGroup>
        </Col>
        <Col md={4} className="text-right p2-3">
          Clients ({widget.clients.filter(item => item > 0).length})<br /> (Leave none selected to apply widget to all)
        </Col>
        <Col md={4} className="text-left p-3 pl-5 maxHpanel">
          {[...this.props.clients]
            .map(client => (
              <Row key={client.id}>
                <Label for={"client_" + client.id}>
                  <Input
                    type="checkbox"
                    name="clients"
                    id={"client_" + client.id}
                    checked={this.props.isFieldNull(this.props.editWidget.clients.findIndex(i => i === parseInt(client.id)) > -1, true)}
                    onChange={e => this.props.onChange(e, 'edit')}
                  />{client.client}
                </Label>
              </Row>
            ))}
        </Col>
      </Row>
    </>
    )
  }

  addRow = () => {
    this.props.info('Widgets.js/addRow');
    return (
      <Row className="py-4 text-left align-items-bottom ">
        <Col>
          <Form inline>
            {/* <FormGroup className="pr-2">
              Add New Workflow
            </FormGroup> */}
            <FormGroup className="pr-2 pb-2">
              <Input
                placeholder="New Widget Name"
                type="text"
                id="widget-add-name"
                name="name"
                value={this.props.isFieldNull(this.props.newWidget.name)}
                onChange={e => this.props.onChange(e)} />
            </FormGroup>
            <FormGroup className="pr-2 pb-2">
              <Input
                placeholder="Description"
                type="text"
                id="widget-add-description"
                name="description"
                value={this.props.isFieldNull(this.props.newWidget.description)}
                onChange={e => this.props.onChange(e)} />
            </FormGroup>
            <FormGroup className="pr-2 pb-2">
              <Input
                placeholder="Types"
                type="text"
                id="widget-add-types"
                name="types"
                value={this.props.isFieldNull(this.props.newWidget.types)}
                onChange={e => this.props.onChange(e)} />
            </FormGroup>
            <FormGroup className="pr-2 pb-2">
              <Input
                placeholder="Module"
                type="text"
                id="widget-add-module"
                name="module"
                value={this.props.isFieldNull(this.props.newWidget.module)}
                onChange={e => this.props.onChange(e)} />
            </FormGroup>
            <FormGroup className="pr-2 pb-2">
              <Input
                placeholder="Configuration"
                type="textarea"
                id="widget-add-configuration"
                name="configuration"
                value={this.props.isFieldNull(this.props.newWidget.configuration)}
                onChange={e => this.props.onChange(e)} />
            </FormGroup>
            <FormGroup className="pr-2 pb-2">
              <Input
                type="checkbox"
                id={"widget-add-active"}
                name="active"
                checked={this.props.isFieldNull(this.props.newWidget.active, true)}
                onChange={e => this.props.onChange(e)} />
              <Label for={"widget-add-active"}>
                Active
              </Label>
            </FormGroup>
          </Form>
        </Col>
        <Col md={3} className="text-right">
          <Button
            disabled={this.props.newWidget.name === ''}
            color="primary"
            onClick={this.props.handleAdd}
          >Add Widget</Button>
        </Col>
      </Row>
    )
  }

  render() {
    this.props.info('Widgets.js/render');
    return (
      <Container className="adminContainer" fluid>
        <ReactDragListView {...this.props.dragProps}>
          {this.props.widgets.map(widget => (
            <Fragment key={widget.widgetId}>{this.props.editWidget.widgetId === widget.widgetId ? this.editRow(widget) : this.standardRow(widget)}</Fragment>
          ))}
          <PermissionWrapper hidden={true} refreshUser={this.props.refreshUser} {...this.props} {...this.state} allowedPermission="Add Widgets">
            {this.addRow()}
          </PermissionWrapper>
        </ReactDragListView>
      </Container>
    );

  }
}

export default Widgets;
